<template>
  <v-navigation-drawer
    v-bind:model-value="
      $vuetify.display.mdAndUp || ($vuetify.display.mdAndDown && showMobileMenu)
    "
    @update:model-value="emitChange"
  >
    <CompanySelector class="mx-3 mt-10 mb-4" />
    <MenuList
      class="px-1"
      :menu-items="menuItems"
      :default-active-item="defaultActiveMenuItem?.id ?? ''"
    />
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import CompanySelector from "@/components/CompanySelector.vue";
import MenuList from "@/components/menu/MenuList.vue";
import { RouterPath } from "@/models/enum/routerPath";
import type { SideMenuItem } from "@/models/sideMenuItem";
import { ref } from "vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { computed } from "vue";

const authenticationStore = useAuthenticationStore();

defineProps<{
  showMobileMenu: boolean;
}>();

const emit = defineEmits<{
  (e: "change", open: boolean): void;
}>();

function emitChange(open: boolean) {
  emit("change", open);
}

const menuItems = ref([
  {
    id: "global-side-menu__home",
    title: "Dashboard",
    path: RouterPath.Home,
    icon: "icon-home-outline",
    visible: !authenticationStore.canAccessCustomerDashboard(),
  },
  {
    id: "global-side-menu__dashboard",
    title: "Dashboard",
    path: RouterPath.Dashboard,
    icon: "icon-home-outline",
    visible: authenticationStore.canAccessCustomerDashboard(),
  },
  {
    id: "global-side-menu__questionnaires",
    title: "Questionnaires",
    path: RouterPath.Questionnaires,
    icon: "icon-survey-outline",
    visible: true,
  },
  {
    id: "global-side-menu__my-suppliers",
    title: "Business relations",
    path: RouterPath.SuppliersRegistry,
    icon: "icon-truck-outline",
    visible: true,
  },
  {
    id: "global-side-menu__users",
    title: "Users",
    path: RouterPath.Team,
    icon: "icon-community-outline",
    visible: true,
  },
  {
    id: "global-side-menu__admin",
    title: "Admin",
    path: RouterPath.AdministratorPage,
    icon: "icon-lockclosed-locked-outline",
    visible: authenticationStore.isAdmin,
  },
  {
    id: "global-side-menu__help",
    title: "Help Center",
    path: RouterPath.Help,
    icon: "icon-help-question-outline",
    visible: true,
  },
] as SideMenuItem[]);

const defaultActiveMenuItem = computed(() =>
  menuItems.value.find((item) => item.visible)
);
</script>
